/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DtoTravelBookingGmgCreate } from '../../models/dto-travel-booking-gmg-create';
import { TravelBookingCreateResponseRedirect } from '../../models/travel-booking-create-response-redirect';

export interface BookingControllerCreateForGmg$Params {
  travel_id: number;
      body: DtoTravelBookingGmgCreate
}

export function bookingControllerCreateForGmg(http: HttpClient, rootUrl: string, params: BookingControllerCreateForGmg$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelBookingCreateResponseRedirect;
}>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerCreateForGmg.PATH, 'post');
  if (params) {
    rb.path('travel_id', params.travel_id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelBookingCreateResponseRedirect;
      }>;
    })
  );
}

bookingControllerCreateForGmg.PATH = '/booking/{travel_id}/gmg';
